import { connect } from 'react-redux';
import StartingCallModal from 'components/StartingCallModal/StartingCallModal';
import { callActions, callSelectors, userProfileSelectors } from '@lifesize/nucleus';
import { closeFullScreenModal } from 'actions/FullScreenModal';
import { navigateToTrialPage } from 'actions/Application';
import { cancelJoinCall } from 'actions/JoinModal';
import { callingError, getCallType, isCallDisconnected } from 'utils/call-utils';
import _get from 'lodash/get';

export const CALL_FAILURE_TIMEOUT = 10000;

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);
  const isGuest = userProfileSelectors.selectIsGuest(state);

  return {
    callId: activeCall.id,
    callName: activeCall.name || activeCall.dialString,
    callStatus: activeCall.state,
    callDialString: activeCall.dialString,
    callType: getCallType(activeCall),
    callingError: callingError(activeCall),
    callFailureReason: activeCall.reason,
    callMeetingType: activeCall.isMeeting ? _get(activeCall, 'remoteContact.meetingType') : '',
    isWebConferencing: _get(activeCall, 'isWebConferencing'),
    guestHasDisconnected: isGuest && _get(state, 'app.joinModal.remoteDisconnect'),
    isVideoEnabled: _get(state, 'app.joinModal.isVideoEnabled'),
    isAudioEnabled: _get(state, 'app.joinModal.isAudioEnabled'),
    isJoinFlowCall: _get(state, 'app.joinModal.isJoinFlowCall'),
    isGuest,
    isCallDisconnected: isCallDisconnected(activeCall),
    callFailureTimeout: CALL_FAILURE_TIMEOUT,
    defaultAudioSetting: _get(state, 'app.settingsModal.defaultAudioSetting'),
    hasVideo: _get(state, 'app.call.hasVideo')
  };
};

const mapDispatchToProps = dispatch => ({
  redialCall: (dialString, isWebConferencing, isJoinFlowCall, media) => {
    if (isWebConferencing) {
      dispatch(closeFullScreenModal());
      dispatch(callActions.webConferenceCall(dialString, media));
    } else {
      dispatch(callActions.call(dialString, media));
    }
  },
  cancelCall: () => {
    dispatch(callActions.cancel());
    dispatch(closeFullScreenModal());
    dispatch(cancelJoinCall());
  },
  clearCall: () => {
    dispatch(callActions.clearCall());
    dispatch(cancelJoinCall());
  },
  navigateToTrialPage: () => dispatch(navigateToTrialPage())
});

const mergeProps = (stateProps, dispatchProps, ownProps) => (
  Object.assign({}, ownProps, stateProps, dispatchProps,
    {
      redialCall: (dialString) => {
        let media = { video: stateProps.hasVideo, audio: stateProps.defaultAudioSetting };
        if (stateProps.isJoinFlowCall) {
          media = { video: stateProps.isVideoEnabled, audio: stateProps.isAudioEnabled };
        }
        return (dispatchProps.redialCall(
          dialString,
          stateProps.isWebConferencing,
          stateProps.isJoinFlowCall,
          media
        ));
      }
    }
  )
);

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(StartingCallModal);
